import { NavigateOptions, useNavigate } from "react-router";
import { CONSTANTS } from "../constants";

type RouteStateType = {
  [CONSTANTS.ROUTES.addMedication]: { patientId: string; patientName: string };
  [CONSTANTS.ROUTES.home]: undefined;
  [CONSTANTS.ROUTES.doctors]: { from: keyof typeof CONSTANTS.ROUTES };
  // [CONSTANTS.ROUTES.otherRoute]: { someParam: number };
};

type NavigateWithState = <T extends keyof RouteStateType>(
  to: T,
  options: NavigateOptions & { state?: RouteStateType[T] }
) => void;

export const useTypedNavigate = (): NavigateWithState => {
  const navigate = useNavigate(); // use react-router's useNavigate hook
  return navigate as NavigateWithState; // cast to the typed version
};
